import type {
  GetNextBuyflowStepResponse,
  BuyflowWidget,
} from '@/lib/TypesOpenApi';

export const getProductWidgets = (
  content: GetNextBuyflowStepResponse | undefined,
  key: keyof BuyflowWidget,
) =>
  // extract product info from widget
  content?.buyflowStep.buyflowWidgets
    ?.map(widget => widget[key]!)
    .filter(Boolean) || [];

export const getProductWidget = (
  content: GetNextBuyflowStepResponse | undefined,
  key: keyof BuyflowWidget,
) => getProductWidgets(content, key)[0];
